import styled from 'styled-components';

export const TopicDetailGrid = styled.div`
  display: grid;
  grid-template-columns: 25% 73%;
  justify-content: space-between;
  grid-gap: 16px;
  margin-top: 16px;

  @media (max-width: 720px) {
    margin-top: 0;
    grid-template-columns: 100%;
    grid-gap: 0;
    .mobileTopSection {
      order: -1;
    }
  }
`;

export const CategoryImage = styled.img`
  max-width: 100%;
  width: 100%;
  height: 54vh;
  object-fit: cover;
  object-position: top;

  @media (max-width: 720px) {
    height: 36vh;
  }
`;

export const BannerContainer = styled.div`
  max-width: 100%;
  width: 100%;
  height: 54vh;
  object-fit: cover;
  object-position: center;
  background-image: url('https://images.myloapp.in/NestJsUploads/1668581912764-defaultimage.webp');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;

  @media (max-width: 720px) {
    height: 36vh;
  }
`;
